import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, ShieldCheck } from "lucide-react";
import { Logo } from "../../components/Logo";
import { useAuth } from "../../lib/auth";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => { if (!loading && user) navigate("/admin/dashboard", { replace: true }); }, [user, loading, navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex noise-dark text-white p-14 flex-col justify-between">
        <Logo dark />
        <div>
          <h1 className="font-display text-4xl font-black leading-tight">Wingman control centre</h1>
          <p className="mt-4 text-white/70 max-w-md">Manage leads, content, SEO and your agent API keys from one dashboard. Built to run on your phone or desktop.</p>
        </div>
        <p className="text-sm text-white/40">© {new Date().getFullYear()} Car To Cash</p>
      </div>
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm text-center">
          <div className="lg:hidden mb-8"><Logo /></div>
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-gold/15"><ShieldCheck className="h-7 w-7 text-brand-navy" /></div>
          <h2 className="mt-6 font-display text-2xl font-extrabold text-brand-navy">Admin sign in</h2>
          <p className="mt-2 text-brand-muted">Sign in with your Google account to access the dashboard.</p>
          <button onClick={login} className="mt-8 w-full inline-flex items-center justify-center gap-2 rounded-full bg-brand-navy px-6 py-4 font-bold text-white hover:bg-brand-navy2 transition-colors" data-testid="google-login-btn">
            <LogIn className="h-5 w-5" /> Continue with Google
          </button>
          <p className="mt-6 text-xs text-brand-muted">Access is restricted to authorised accounts.</p>
        </div>
      </div>
    </div>
  );
}
